import * as constants from './constants';
import {post} from "../../../utils/request";
import {
    USER_SMS_CODE,
    USER_UPDATE_INFO,
    USER_INFO
} from '../../../utils/api';

export const UserInfo = (Entity) => ({
    type: constants.USER_INFO,
    value: Entity
});

export const sendMessageActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_SMS_CODE, params);
        return result;
    }
}

export const updateUserInfo = (params) => {
    return async (dispatch) => {
        const result = await post(USER_UPDATE_INFO, params);
        return result;
    }
}

export const getUserInfo = () => {
    return (dispatch) => {
        return post(USER_INFO, {})
            .then((response) => {
                return dispatch(UserInfo(response.data));
            });
    }
};
